import type { ReactElement } from "react";
import { GroupedTableHeaderCellProps } from "./GroupedTableHeaderCell.types";
import { SmallBody } from "src/components/Text";
import { GroupedTableEmbeddedToolbar } from "../GroupedTableEmbeddedToolbar";
import { GroupedTableSortButton } from "../GroupedTableSortButton";
import { useGroupedTableInternal } from "../utils";
import ContentWithTooltip from "src/ui/components/ContentWithTooltip/ContentWithTooltip";

/**
 * GroupedTableHeaderCell component
 *
 * @param {GroupedTableHeaderCellProps} props - The component props
 * @returns {ReactElement | null} The rendered component
 */
function GroupedTableHeaderCell<TItemType>({
    column,
    renderToolbar,
    sort,
}: GroupedTableHeaderCellProps<TItemType>): ReactElement | null {
    const { setSort } = useGroupedTableInternal<TItemType>();

    return (
        <div className="GroupedTableHeaderCell">
            {column.tooltip ? (
                <ContentWithTooltip tooltip={column.tooltip}
                                    className="GroupedTableHeaderCell-Text">
                    <SmallBody color="contentDark">
                        {column.header}
                    </SmallBody>
                </ContentWithTooltip>
            ) : (
                <SmallBody className="GroupedTableHeaderCell-Text"
                           color="contentDark">
                    {column.header}
                </SmallBody>
            )}
            <div className="buttons">
                {renderToolbar && (
                    <div className="embedded-toolbar">
                        <GroupedTableEmbeddedToolbar />
                    </div>
                )}
                {column.sortable && (
                    <GroupedTableSortButton
                        column={column}
                        onChange={setSort}
                        sort={sort} />
                )}
            </div>
        </div>
    );
}

export default GroupedTableHeaderCell;

